var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-browse",
    {
      key: _vm.refresh,
      attrs: {
        "data-source": _vm.dataSource,
        "selected-items": _vm.selectedItems,
        "clear-view-settings-filters": _vm.generalSettings.ClearF3SearchFilter,
        "controls-disabled": true,
        "search-enabled": true,
        view: _vm.view,
        multiple: "",
      },
      on: {
        "select-changed": function ($event) {
          return _vm.onSelectChanged($event)
        },
      },
    },
    [
      _vm._t("header", null, { slot: "header" }),
      _c(
        "template",
        { slot: "browse-action-buttons" },
        [
          _c(
            "w-button-bar",
            { staticClass: "ml" },
            [
              !_vm.disableContactFilter
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.filterOnCurrentContactTooltip,
                          expression: "filterOnCurrentContactTooltip",
                        },
                      ],
                      class: { cancel: _vm.filterOnCurrentContactEnabled },
                      on: {
                        click: function ($event) {
                          _vm.filterOnCurrentContactEnabled =
                            !_vm.filterOnCurrentContactEnabled
                        },
                      },
                    },
                    [
                      _c("w-fa", {
                        staticClass: "no-margin",
                        attrs: { icon: _vm.filterOnCurrentContactIcon },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.filterOnCurrentImportTooltip,
                      expression: "filterOnCurrentImportTooltip",
                    },
                  ],
                  class: { cancel: _vm.filterOnAlreadyImportedEnabled },
                  on: {
                    click: function ($event) {
                      _vm.filterOnAlreadyImportedEnabled =
                        !_vm.filterOnAlreadyImportedEnabled
                    },
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "no-margin",
                    attrs: { icon: "file-import" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bookyear-wrapper" },
            [
              _c("w-select", {
                attrs: {
                  items: _vm.bookYearItems,
                  value: _vm.selectedBookYear,
                },
                on: {
                  input: function ($event) {
                    return _vm.onBookYearChange($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-button",
            {
              staticClass: "cancel ml",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [
              _c(
                "div",
                [
                  _c("w-fa", { attrs: { icon: "times" } }),
                  _vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " "),
                ],
                1
              ),
            ]
          ),
          _c(
            "w-button",
            {
              staticClass: "ml",
              attrs: { disabled: _vm.confirmDisabled },
              on: {
                "~click": function ($event) {
                  return _vm.select.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                [
                  _c("w-fa", { attrs: { icon: "check" } }),
                  _vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " "),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("template", { slot: "top" }),
      _vm._t("bottom", null, { slot: "bottom" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }